import { render, staticRenderFns } from "./StopWords.vue?vue&type=template&id=29c2da06&scoped=true"
import script from "./StopWords.vue?vue&type=script&lang=js"
export * from "./StopWords.vue?vue&type=script&lang=js"
import style0 from "./StopWords.vue?vue&type=style&index=0&id=29c2da06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2da06",
  null
  
)

export default component.exports